const Branch = {
  path: "",
  name: "",
  redirect: "/branch-management",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/branch-management",
      redirect: "/branch-management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Branch Management",
      meta: {
        requiresAuth: true,
        activeUrl: "/branch-management",
        parent: "branch",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageBranch"),
          meta: {
            requiresAuth: true,
            activeUrl: "/branch-management",
            parent: "branch",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Branch Management Detail",
          component: () => import("@/views/pages/manageBranch/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,

            activeUrl: "/branch-management",
            parent: "branch",
            lv: 3,
          },
        },
        {
          path: "inventory/:id",
          name: "Inventory Detail",
          component: () => import("@/views/pages/manageBranch/Inventory.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,

            activeUrl: "/branch-management",
            parent: "branch",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Branch;
